var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServiceInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -638.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Insurance",
    transform: "translate(3116.000000, 638.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5136021,14.2222222 L17.5136021,26.4126984 C17.5136021,29.4928254 15.0240519,32 11.965577,32 C10.3788418,32 8.86372663,31.3081905 7.80657567,30.1033651 L7.81363679,30.096254 C7.57961101,29.8280635 7.43334489,29.4816508 7.43334489,29.095619 C7.43334489,28.2544762 8.11020395,27.5738413 8.94543391,27.5738413 C9.39633704,27.5738413 9.79579485,27.776 10.0731961,28.0899048 L10.0762223,28.0868571 C10.5573874,28.6364444 11.2463512,28.952381 11.9645683,28.952381 C13.3556095,28.952381 14.4874066,27.8135873 14.4874066,26.4126984 L14.4874066,14.2222222 L0,14.2222222 C0.994609589,6.20596825 7.77127006,0 16.0005044,0 C24.2287299,0 31.0053904,6.20596825 32,14.2222222 L17.5136021,14.2222222 Z",
    id: 147
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServiceInsurance);
export default __webpack_public_path__ + "static/media/bank-product-and-service-insurance.95fed9bf.svg";
export { ForwardRef as ReactComponent };